import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL ?? ""}/api`;
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "X-PokeBinder-Request": "1" },
});

// Remove credentials persisted by older versions. New sessions use HttpOnly cookies.
export const clearLegacyTokens = () => {
  localStorage.removeItem("pb_access");
  localStorage.removeItem("pb_refresh");
};

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    const skip = orig?.url?.startsWith("/auth/") && orig.url !== "/auth/me";
    if (err.response?.status === 401 && orig && !orig._retry && !skip) {
      orig._retry = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh", {}).finally(() => { refreshing = null; });
        }
        await refreshing;
        return api(orig);
      } catch {
        clearLegacyTokens();
        if (window.location.pathname !== "/login") window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const cardImg = (image, q = "low") => (typeof image === "string" && image ? (/\.(webp|png|jpe?g)(\?.*)?$/i.test(image) ? image : `${image}/${q}.webp`) : null);
export const logoImg = (logo) => (logo ? `${logo}.webp` : null);
export const usd = (v) => (v == null ? "—" : `$${Number(v).toFixed(2)}`);
export const gbp = (v) => (v == null ? "—" : `£${Number(v).toFixed(2)}`);
export const eur = (v) => (v == null ? "—" : `€${Number(v).toFixed(2)}`);
export const VARIANT_LABELS = { normal: "Normal", holo: "Holo", reverse: "Reverse Holo", firstEdition: "1st Edition", wPromo: "W Promo" };
export { printingLabel as vLabel } from './printings';
export const TYPE_COLORS = {
  Grass: "#4ADE80", Fire: "#F87171", Water: "#60A5FA", Lightning: "#FACC15", Psychic: "#C084FC",
  Fighting: "#FB923C", Darkness: "#475569", Metal: "#94A3B8", Fairy: "#F9A8D4", Dragon: "#C8A951", Colorless: "#E2E8F0",
};
export const artwork = (id) => `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`;
